import React from 'react'
import { FormattedMessage, injectIntl } from "gatsby-plugin-intl"
import { SimpleImg } from 'react-simple-img'
import Fade from 'react-reveal/Fade';

import mapa from '../images/mapa-certificaciones.png'
import certif1 from '../images/certi-ctpat.png'
import certif2 from '../images/certi-iso.png'
import certif3 from '../images/certi-oea.png'
import certif4 from '../images/certi-hazmat.png'
import certif5 from '../images/certi-iata.png'
import certif6 from '../images/certi-wca.png'
import certif7 from '../images/certi-alna.png'

const Certificaciones = () => {
	return (
		<section className="certificaciones-widget">
			<Fade bottom>
				<div className="cont">
					<header><FormattedMessage id="certificaciones.titulo" /></header>
					<ul>
						<li>
							<SimpleImg src={certif1} alt="C-TPAT" width={135} height={55} placeholder={false} />
						</li>
						<li>
							<SimpleImg src={certif2} alt="ISO 9001:2015" width={83} height={51} placeholder={false} />
						</li>
						<li>
							<SimpleImg src={certif3} alt="Operador Económico Autorizado" width={126} height={68} placeholder={false} />
						</li>
						<li>
							<SimpleImg src={certif4} alt="Hazmat" width={121} height={19} placeholder={false} />
						</li>
						<li>
							<SimpleImg src={certif5} alt="IATA" width={126} height={68} placeholder={false} />
						</li>
						<li>
							<SimpleImg src={certif6} alt="WCA" width={126} height={88} placeholder={false} />
						</li>
						<li>
							<SimpleImg src={certif7} alt="ALNA" width={176} height={68} placeholder={false} />
						</li>
					</ul>
				</div>
			</Fade>
			<div className="mapa">
				<SimpleImg src={mapa} alt="Mapa" width={1274} height={663} placeholder={false} />
			</div>
		</section>
	)
}

export default injectIntl(Certificaciones)
